export interface UpdateOrganizationInput {
  id: string;
  billingAddress: BillingAddress;
  logoUrl: string;
  name: string;
  phone: string;
  link: string;
}

export interface BillingAddress {
  billingStreet: string;
  billingCity: string;
  billingCountry: string;
  billingPostalCode: string;
  billingState: string;
}
